// Calendar inputs represent local days, not instants in UTC.
export const calendarDate = date => [date.getFullYear(),
  String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
